
export default {
  // Airport details
  "rank": "Rang",
  "hand_check_rate": "Handkontrollrate",
  "reviews": "Bewertungen",
  "loading_airport": "Flughafendetails werden geladen...",
  "airport_not_found": "Flughafen nicht gefunden",
  "airport_reviews": "Flughafen-Bewertungen",
  "no_reviews_yet_share": "Noch keine Bewertungen",
  "share_film_community": "Teilen Sie Ihre Erfahrung mit der Filmgemeinschaft!",
  "add_review_button": "Bewertung hinzufügen",
  "back_to_lenses": "Zurück zu Objektiven",
  "failed_load_lens": "Objektivdetails konnten nicht geladen werden",
  "lens_not_found": "Objektiv nicht gefunden",
  "favorite_airports": "Lieblings-Flughäfen",
  "no_favorite_airports": "Noch keine Lieblings-Flughäfen",
  "back_to_cameras": "Zurück zu Kameras",
};
